<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.16668 5L6.08334 2.91667C5.86964 2.67558 5.5711 2.52631 5.25001 2.5C4.56918 2.5 4.00001 3.06917 4.00001 3.75V14.1667C4.00001 14.6087 4.1756 15.0326 4.48817 15.3452C4.80073 15.6577 5.22465 15.8333 5.66668 15.8333H15.6667C16.1087 15.8333 16.5326 15.6577 16.8452 15.3452C17.1577 15.0326 17.3333 14.6087 17.3333 14.1667V10M9.00001 4.16667L7.33334 5.83333M2.33334 10H19M6.50001 15.8333V17.5M14.8333 15.8333V17.5" stroke="#30485E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "BathIcon"
}
</script>
